export const DESTINATION_OVERVIEW_DATA_ID_CONTRACT = {
  base: 'destination-overview',
  container: 'container',
  loadingShimmer: '',
  retryApiAlert: ''
};
